var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.77 7.662c1.542.915 2.313 1.372 2.448 2.025a1.5 1.5 0 0 1 0 .623c-.135.653-.906 1.11-2.447 2.025l-5.25 3.116c-1.542.914-2.312 1.372-2.93 1.165a1.45 1.45 0 0 1-.525-.311c-.483-.447-.483-1.361-.483-3.19V6.882c0-1.83 0-2.744.483-3.19.152-.141.33-.247.525-.312.618-.206 1.388.251 2.93 1.166z"
  })));
};
export default SvgPlay;